import { createApiClient } from "@trillion/ui";
import { getEnv } from "@trillion/ui/lib/env";

export interface McpConnection {
  authorization_id: string;
  connection_id: string;
  client_id: string;
  display_name: string;
  created_at: string;
}

export interface McpConnectionsView {
  connections: McpConnection[];
  csrf_token: string;
}

const api = createApiClient(() => getEnv("PASSPORT_API_URL"));
export const mcpConnectionsApi = {
  list(signal?: AbortSignal) {
    return api.request<McpConnectionsView>("/api/mcp/connections", { signal });
  },
  disconnect(authorizationId: string, csrfToken: string, signal?: AbortSignal) {
    return api.request<void>(`/api/mcp/connections/${encodeURIComponent(authorizationId)}`, {
      method: "DELETE", headers: { "X-CSRF-TOKEN": csrfToken }, signal,
    });
  },
};
